import { containerConfigurationTemplatesV2Ops } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("container-config-template"),
  endpoint: "container-configuration-templates",
  operations: containerConfigurationTemplatesV2Ops,
  apiVersion: "v2",
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("Container configuration template"),
  name: (t) => t("Container configuration templates"),
  syncCustomerFilter: true,
  dependencies: ["container"],
});

export default conf;
